export default "__VITE_ASSET__DEW21kqY__"